import React from 'react';
import { ButtonContainer } from './styled';

interface ICtaButtonProps {
  text: string;
  backgroundColor: string;
  textColor: string;
}

const CtaButton = (props: ICtaButtonProps) => {
  return (
    <ButtonContainer buttonBackground={props.backgroundColor} textColor={props.textColor} aria-label='Click here to open Web Chat and get help.'>
      <div className='css-wb64st'><span>{`${props.text}`}</span></div>
      <div className='css-b5a08c'>
        <div className='css-y8bnhq'>
          <svg width='2rem' height='100%' viewBox='0 0 24 24'>
            <path
              d='M10.64 14.984h-.343a4.147 4.147 0 0 1-.719-.047 4.527 4.527 0 0 1-.476.422c-.245.198-.534.407-.868.625a9.02 9.02 0 0 1-1.054.594c-.37.177-.716.292-1.04.344l-.046.008a.337.337 0 0 1-.32-.102.376.376 0 0 1-.102-.265.305.305 0 0 1 .031-.14c.11-.21.284-.53.508-.962.224-.432.336-.83.336-1.195a5.475 5.475 0 0 1-1.125-.844 4.576 4.576 0 0 1-.797-1.063A5.327 5.327 0 0 1 4 9.875c0-.677.17-1.312.508-1.906a4.982 4.982 0 0 1 1.398-1.547 7.194 7.194 0 0 1 2.078-1.04A8.254 8.254 0 0 1 10.531 5c.896 0 1.737.128 2.524.383a6.988 6.988 0 0 1 2.054 1.039 5.059 5.059 0 0 1 1.383 1.547c.339.594.508 1.229.508 1.906.01.76-.146 1.456-.469 2.086a4.83 4.83 0 0 1-1.343 1.617c-.573.448-1.25.794-2.032 1.04a8.37 8.37 0 0 1-2.515.366zM20 13.906c0 .73-.177 1.373-.531 1.93-.354.557-.901 1.023-1.64 1.398v.032c0 .323.062.698.187 1.125.125.427.24.729.343.906a.305.305 0 0 1 .032.125.318.318 0 0 1-.328.328h-.094c-.552-.094-1.11-.375-1.672-.844-.563-.469-.901-.776-1.016-.922-.125.01-.234.019-.328.024a5.362 5.362 0 0 1-.297.008h-.297a7.53 7.53 0 0 1-1.445-.133 6.147 6.147 0 0 1-1.273-.39 5.142 5.142 0 0 1-1.938-1.445c.021-.022 6.804.702 8.352-4.751.047-.188.08-.37.101-.547.657.385 1.128.839 1.414 1.36.287.52.43 1.12.43 1.796z'
              fill='currentColor' fill-rule='evenodd'>
            </path>
          </svg>
        </div>
      </div>
    </ButtonContainer>
  );
};

export default CtaButton;
